module.exports = __webpack_public_path__ + "85d0f33a829d26fc00eafa442ffa0d0a.woff";